export enum ContentLtiAction {
  PLAY = 'play',
  REPORT = 'report',
}
